import React from "react";
import { Link } from "react-router-dom";
// images
import Notification from "../images/notification.svg";
import Sms from "../images/sms.svg";
import Setting from "../images/setting.svg";
import Profile from "../images/profile.png";

import "../css/preference.css";

const Preference = () => {
  return (
    <div className="preference">
      <ul>
        <li className="preference-1">
          <Link to="/home">
            <img src={Notification} alt="" />
          </Link>
        </li>
        <li className="preference-2">
          <Link to="/home">
            <img src={Sms} alt="" />
          </Link>
        </li>
        <li className="preference-3">
          <Link to="/home">
            <img src={Setting} alt="" />
          </Link>
        </li>
        <li className="preference-4">
          <Link to="/home">
            <img src={Profile} alt="" />
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Preference;
